import React from 'react'
import { Box, IconButton, Tooltip } from '@mui/material'
import { motion } from 'framer-motion'
import { useTranslation } from 'react-i18next'
import PhoneIcon from '@mui/icons-material/Phone'
import WhatsAppIcon from '@mui/icons-material/WhatsApp'

// غيّر الأرقام دي بأرقامك الحقيقية
const PHONE_NUMBER = '+971585535444'
const WHATSAPP_NUMBER = '971585535444' // بدون + وبدون مسافات لرابط واتساب

const containerVariants = {
  hidden: {},
  visible: {
    transition: {
      staggerChildren: 0.15,
      delayChildren: 0.3,
    },
  },
}

const buttonVariants = {
  hidden: { opacity: 0, scale: 0.4, y: 30 },
  visible: {
    opacity: 1,
    scale: 1,
    y: 0,
    transition: { type: 'spring', stiffness: 260, damping: 18 },
  },
}

// كومبوننت زرار عائم فيه حلقة نبض مستمرة تلفت الانتباه
const PulsingFab = ({ href, label, color, ringColor, icon, delay = 0 }) => {
  return (
    <Tooltip title={label} placement="left" arrow>
      <Box
        component={motion.a}
        href={href}
        target={href?.startsWith('http') ? '_blank' : undefined}
        rel={href?.startsWith('http') ? 'noopener noreferrer' : undefined}
        variants={buttonVariants}
        whileHover={{ scale: 1.08 }}
        whileTap={{ scale: 0.94 }}
        sx={{
          position: 'relative',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          width: { xs: 52, md: 58 },
          height: { xs: 52, md: 58 },
          borderRadius: '50%',
          bgcolor: color,
          color: '#fff',
          boxShadow: '0 8px 20px rgba(0,0,0,0.35)',
          textDecoration: 'none',
          cursor: 'pointer',
        }}
      >
        {/* حلقات النبض للتنبيه */}
        <Box
          sx={{
            position: 'absolute',
            inset: 0,
            borderRadius: '50%',
            border: `2px solid ${ringColor}`,
            animation: `pulseRing 2.4s ease-out ${delay}s infinite`,
          }}
        />
        <Box
          sx={{
            position: 'absolute',
            inset: 0,
            borderRadius: '50%',
            border: `2px solid ${ringColor}`,
            animation: `pulseRing 2.4s ease-out ${delay + 1.2}s infinite`,
          }}
        />

        <Box sx={{ position: 'relative', zIndex: 1, display: 'flex', fontSize: { xs: 24, md: 26 } }}>
          {icon}
        </Box>
      </Box>
    </Tooltip>
  )
}

export const FloatingButtons = () => {
  const { t, i18n } = useTranslation()
  const isArabic = (i18n.language || 'ar').startsWith('ar')

  const callLabel = isArabic ? 'اتصل بنا' : 'Call Us'
  const whatsappLabel = isArabic ? 'راسلنا واتساب' : 'Chat on WhatsApp'

  return (
    <>
      {/* الكيفريمز الخاصة بتأثير النبض */}
      <style>
        {`
          @keyframes pulseRing {
            0% {
              transform: scale(1);
              opacity: 0.7;
            }
            100% {
              transform: scale(1.7);
              opacity: 0;
            }
          }
        `}
      </style>

      <Box
        component={motion.div}
        variants={containerVariants}
        initial="hidden"
        animate="visible"
        sx={{
          position: 'fixed',
          bottom: { xs: 20, md: 32 },
          right: { xs: 16, md: 32 },
          zIndex: 1300,
          display: 'flex',
          flexDirection: 'column',
          gap: { xs: 1.5, md: 2 },
        }}
      >
        <PulsingFab
          href={`tel:${PHONE_NUMBER}`}
          label={callLabel}
          color="#7A2E3A"
          ringColor="rgba(122,46,58,0.7)"
          icon={<PhoneIcon fontSize="inherit" />}
          delay={0}
        />
        <PulsingFab
          href={`https://wa.me/${WHATSAPP_NUMBER}`}
          label={whatsappLabel}
          color="#25D366"
          ringColor="rgba(37,211,102,0.7)"
          icon={<WhatsAppIcon fontSize="inherit" />}
          delay={0.4}
        />
      </Box>
    </>
  )
}